<div>
  <app-loading-spinner *ngIf="!geneDetails && !apiError"></app-loading-spinner>
  <app-api-error-display *ngIf="apiError" [error]="apiError"></app-api-error-display>
  <div id="gene-details" class="details-page" *ngIf="geneDetails && !apiError">
    <app-social-contact [subject]="'Comment or problem report for ' + displayNameLong()"></app-social-contact>
    <div class="details-page-name-and-id">
    <div class="gene-details-name-id">
      <span class="details-page-name-and-id-prefix">Gene:</span>
    <span class="gene-name" *ngIf="!isConfiguredOrganism && organism">
      <span class="name-id">{{organism.common_name}}</span>
    </span>
    <span *ngIf="geneDetails.name">
      <span class="name-id"><span class="name-id-highlight">{{geneDetails.name}}</span> / {{geneDetails.uniquename}}</span>
    </span>
    <span class="gene-name" *ngIf="!geneDetails.name">
      <span class="name-id">{{geneDetails.uniquename}}</span>
    </span>
    </div>
    </div>

    <div class="details-and-transcripts-note">
    <div id="gene-summary" class="details-page-summary">
          <div class="details-label">Gene symbol</div>
          <div>
            <span *ngIf="geneDetails.name" class="gene-name">{{geneDetails.name}}</span>
            <span *ngIf="!geneDetails.name" class="no-gene-name">(none)
              <app-help-link *ngIf="noGeneNameRoute" [route]="noGeneNameRoute"
                [title]="'No official gene symbol assigned, click to submit one'">
              </app-help-link>
            </span>
          </div>
          <div class="details-label"><span *ngIf="showCharacterisationStatus()">Characterisation status</span></div>
          <div><span *ngIf="showCharacterisationStatus()">{{geneDetails.characterisation_status}}</span></div>
          <div class="details-label">
            <span *ngIf="products.length > 1">Products</span>
            <span *ngIf="products.length <= 1">Product</span>
          </div>
          <div *ngIf="products.length > 1"><ul class="summary-product-list"><li *ngFor="let product of products">{{product}}</li></ul></div>
          <div *ngIf="products.length <= 1"><span *ngIf="products.length == 1">{{products[0]}}</span></div>
          <div class="details-label">Feature type</div>
          <div>{{displayFeatureType}}</div>
          <div class="details-label">Systematic ID</div>
          <div>{{geneDetails.uniquename}}</div>
          <div *ngIf="productSizeOfTranscript1.length != 0" class="details-label">Product size
            <span *ngIf="transcriptCount > 1">(of transcript 1)</span>
          </div>
          <div *ngIf="productSizeOfTranscript1.length != 0">{{productSizeOfTranscript1}}</div>
          <div class="details-label" *ngIf="!isConfiguredOrganism">Organism</div>
          <div *ngIf="!isConfiguredOrganism">{{organismLongName}}</div>
          <div *ngIf="displayLocation" class="details-label">Genomic location</div>
          <div *ngIf="displayLocation">
            <table class="genomic-location">
              <tr>
                <td [attr.rowspan]="displayLocation.length - 1">
                  {{displayLocation[0]}},
                </td>
                <td>{{displayLocation[1]}}
                  <ng-template #rnaLocationWarning>
                    {{locationWarning}}
                  </ng-template>

                  <span class="location-warning" *ngIf="locationWarning"
                        triggers="mouseenter:mouseleave" placement="bottom" container="body"
                        [popover]="rnaLocationWarning">
                    <fa-icon [icon]="faWarning"></fa-icon>
                  </span>
                  <span *ngIf="sourcePublications.length == 1">
                    <app-reference-short
                      [reference]="sourcePublications[0]"
                      [linkText]="'Source ...'"></app-reference-short>
                  </span>
                  <span *ngIf="sourcePublications.length > 1">
                    <app-reference-short
                      *ngFor="let refPub of sourcePublications; let i = index"
                      [reference]="refPub"
                      [linkText]="'[Source ' + (i+1) + ']'"></app-reference-short>
                  </span>
                </td>
              </tr>
              <tr *ngIf="displayLocation.length > 2">
                <td>{{displayLocation[2]}}</td>
              </tr>
            </table>
          </div>
          <div *ngIf="synonymsDisplay.length > 0" class="details-label">Synonyms</div>
          <div *ngIf="synonymsDisplay.length > 0">{{synonymsDisplay}}</div>
          <div class="details-label"><span *ngIf="geneDetails.name_descriptions.length > 0">Name description</span></div>
          <div>
            <span *ngFor="let nameDesc of geneDetails.name_descriptions; let i = index">
              {{nameDesc}}<span *ngIf="i < geneDetails.name_descriptions.length - 1">,<br/></span>
            </span>
          </div>
    </div>

    <div class="gene-transcripts-note" *ngIf="geneDetails.transcripts.length > 1">
      Note: this gene has {{geneDetails.transcripts.length}} transcripts
      (<a pageScroll href="#transcript_view">see details</a>)
      <span *ngIf="proteinCount == 1">with 1 unique translation</span>
      <span *ngIf="proteinCount > 1">with {{proteinCount}} unique translations</span>
    </div>
    </div>

    <div id="gene-details-menu">
      <app-details-page-menu *ngIf="geneDetails"
                             [title]="(geneDetails.name || geneDetails.uniquename) + ' summary'"
                             [onScreenItems]="onScreenItems"
                             [menuItems]="menuItems"></app-details-page-menu>
    </div>

    <div *ngIf="externalLinks && externalLinks.length > 0"
         class="details-page-external-links">
      <div>External link<span *ngIf="externalLinks.length > 1">s</span>:</div>
      <ul>
        <li *ngFor="let externalLink of externalLinks">
          <a href="{{externalLink.link}}">
            <span [innerHTML]="externalLink.text"></span>
          </a>
        </li>
      </ul>
    </div>

    <div *ngIf="currentGeneBrowserTracks.length != 0">
      <div class="track-picker-message" *ngIf="!trackPickerVisible">
        <a (click)="showTrackPicker()">View sequence-based datasets associated with {{geneDetails.name || geneDetails.uniquename}} in JBrowse ...</a>
      </div>

      <app-jbrowse-track-picker *ngIf="trackPickerVisible" [identifier]="geneDetails.name" [identifierType]="'gene'">
      </app-jbrowse-track-picker>
    </div>

    <div class="gene-page-widgets">
      <app-gene-page-widgets *ngIf="isConfiguredOrganism"
                             [geneDetails]="geneDetails">
      </app-gene-page-widgets>
    </div>

    <div *ngFor="let annotationTypeName of annotationTypeOrderNames">

      <div *ngIf="geneDetails.cv_annotations[annotationTypeName]">
        <app-quant-gene-ex-table id="{{annotationTypeName}}"
                                 intersectionObserver
                                 (intersection)="intersect(annotationTypeName, $event.intersect)"
                                 *ngIf="annotationTypeName == 'quantitative_gene_expression'"
                                 [scope]="'gene'"
                                 [geneDetails]="geneDetails"
                                 [hideColumns]="['gene']"
                                 [annotationTable]="geneDetails.cv_annotations[annotationTypeName]"></app-quant-gene-ex-table>

        <app-annotation-table id="{{annotationTypeName}}"
                              *ngIf="annotationTypeName != 'quantitative_gene_expression'"
                              intersectionObserver
                              (intersection)="intersect(annotationTypeName, $event.intersect)"
                              (annotationTableIntersection)="subTableIntersect($event)"
                              [scope]="'gene'"
                              [annotationTypeName]="annotationTypeName"
                              [geneDetails]="geneDetails"
                              [hideColumns]="['gene', 'desc-rel', 'genotype_background', 'allele_promoters']"
                              [annotationTable]="geneDetails.cv_annotations[annotationTypeName]"></app-annotation-table>
      </div>

      <app-misc-annotation-table id="{{annotationTypeName}}"
                                 *ngIf="annotationTypeName == 'miscellaneous' && hasMiscAnnotations()"
                                 intersectionObserver
                                 (intersection)="intersect(annotationTypeName, $event.intersect)"
                                 [annotationTypeNames]="miscAnnotationTypeNames"
                                 [geneDetails]="geneDetails"></app-misc-annotation-table>

      <app-protein-features id="{{annotationTypeName}}"
                            *ngIf="annotationTypeName == 'protein_domains_and_properties' && showProteinFeatures"
                            intersectionObserver
                            (intersection)="intersect(annotationTypeName, $event.intersect)"
                            [geneDetails]="geneDetails"></app-protein-features>


      <app-interaction-annotation-table *ngIf="annotationTypeName == 'physical_interactions'"
                                        id="{{annotationTypeName}}"
                                      intersectionObserver
                                      (intersection)="intersect(annotationTypeName, $event.intersect)"
                                      [annotationTypeName]="annotationTypeName"
                                      [currentGene]="geneDetails"
                                      [annotationTable]="geneDetails.physical_interactions"></app-interaction-annotation-table>

      <app-genetic-interaction-annotation-table
          *ngIf="annotationTypeName == 'genetic_interactions'"
          id="{{annotationTypeName}}"
          intersectionObserver
          (intersection)="intersect(annotationTypeName, $event.intersect)"
          [annotationTypeName]="annotationTypeName"
          [currentGene]="geneDetails"
          [annotationTable]="geneDetails.genetic_interactions">
      </app-genetic-interaction-annotation-table>

      <app-ortholog-annotation-table *ngIf="annotationTypeName == 'orthologs' && showOrthologsSection()"
                                     id="{{annotationTypeName}}"
                                     intersectionObserver
                                     (intersection)="intersect(annotationTypeName, $event.intersect)"
                                     [currentGene]="geneDetails"
                                     [annotationTable]="geneDetails.ortholog_annotations"></app-ortholog-annotation-table>
      <app-paralog-annotation-table *ngIf="annotationTypeName == 'paralogs'"
                                    id="{{annotationTypeName}}"
                                    intersectionObserver
                                    (intersection)="intersect(annotationTypeName, $event.intersect)"
                                    [annotationTable]="geneDetails.paralog_annotations"></app-paralog-annotation-table>
      <app-target-of-annotation-table *ngIf="annotationTypeName == 'target_of'"
                                      id="{{annotationTypeName}}"
                                      intersectionObserver
                                      (intersection)="intersect(annotationTypeName, $event.intersect)"
                                      [geneDetails]="geneDetails"
                                      [annotationTable]="geneDetails.target_of_annotations"></app-target-of-annotation-table>
    </div>

    <app-transcript-view id="transcript_view"
                         *ngIf="geneDetails!.transcripts.length > 0"
                         intersectionObserver
                         (intersection)="intersect('transcript_view', $event.intersect)"
                         [geneDetails]="geneDetails"></app-transcript-view>

    <app-complex-viewer id="complex_viewer"
                        *ngIf="geneDetails!.complexes.length > 0" intersectionObserver
                        (intersection)="intersect('complex_viewer', $event.intersect)"
                        [geneDetails]="geneDetails"></app-complex-viewer>

    <app-transcript-sequence-select *ngIf="isConfiguredOrganism" id="transcript-sequence"
                                    intersectionObserver
                                    (intersection)="intersect('transcript-sequence', $event.intersect)"
                                    [geneDetails]="geneDetails"></app-transcript-sequence-select>

    <app-gene-history-table id="gene-history"
        *ngIf="geneDetails.gene_history.length"
        intersectionObserver
        (intersection)="intersect('gene-history', $event.intersect)"
        [geneDetails]="geneDetails">
    </app-gene-history-table>

    <app-gene-external-references *ngIf="isConfiguredOrganism" id="external-refs"
                                  intersectionObserver
                                  (intersection)="intersect('external-refs', $event.intersect)"
                                  [geneDetails]="geneDetails"></app-gene-external-references>

    <app-gene-references-table id="literature"
                               intersectionObserver
                               (intersection)="intersect('literature', $event.intersect)"
                               [geneDetails]="geneDetails"
                               [references]="geneDetails.references"></app-gene-references-table>
  </div>
</div>
